import { produce } from "immer";
import { createEntityAdapter } from "../../helpers/store/create-entity-adapter";
import { ModalEntity } from "../interfaces/globalEntity";
import {
  GlobalActions,
  globalInitAction,
  setGlobalLoadingAction,
  setLoadingAction,
  setModalAction,
  setInternalModalAction,
  setSideBarCollapsedAction,
  setSideBarOpenAction,
  deleteModalAction,
  deleteInternalModalAction
} from "./actions";

export interface GlobalState {
  loadings: Record<string, boolean>;
  modals: {
    ids: string[];
    entities: Record<string, ModalEntity>;
  };
  internalModals: {
    ids: string[];
    entities: Record<string, ModalEntity>;
  };
  globalLoading: boolean;
  inSideBarOpen: boolean;
  isSideBarCollapsed: boolean;
}

const initialState: GlobalState = {
  globalLoading: false,
  loadings: {},
  modals: {
    ids: [],
    entities: {},
  },
  internalModals: {
    ids: [],
    entities: {},
  },
  inSideBarOpen: false,
  isSideBarCollapsed: true,
};

const modalsAdapter = createEntityAdapter<ModalEntity>((entity) => entity.id);

export default produce(
  (draft: GlobalState = initialState, action: GlobalActions) => {
    switch (action.type) {
      case setModalAction.type:
        modalsAdapter.setOne(action.entity, draft.modals);
        modalsAdapter.moveToPosition(
          action.entity.id,
          draft.modals.ids.length - 1,
          draft.modals
        );
        return draft;
      case setInternalModalAction.type:
        modalsAdapter.setOne(action.entity, draft.internalModals);
        return draft;
      case deleteModalAction.type:
        modalsAdapter.removeOne(action.id, draft.modals);
        return draft;
      case deleteInternalModalAction.type:
        modalsAdapter.removeOne(action.id, draft.internalModals);
        return draft;
      case setSideBarOpenAction.type: 
         draft.inSideBarOpen = action.value
        return draft;
      case setSideBarCollapsedAction.type: 
        draft.isSideBarCollapsed = action.value
        return draft;
      case setLoadingAction.type:
        draft.loadings = {
          ...draft.loadings,
          [action.entity.id]: action.entity.value,
        };
        return draft;
      case setGlobalLoadingAction.type:
        draft.globalLoading = action.value;
        return draft;
      case globalInitAction.type:
        return initialState;
      default:
        return draft;
    }
  }
);
